import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function GoodsReceiving() {
  return <WarehouseOpsPage mode="receipt" title="Goods Receiving" subtitle="Receive and verify shipments" />;
}
